import React from 'react';
import * as S from './style';
import { Label } from 'components';
import { getServiceStatus } from 'commons/ZimssaHelper';

interface Props {
    serviceTypeName?: string;
    description?: string;
    serviceName?: string;
    serviceImage?: string;
    serviceStatus?: string;
    onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function BtnService({ serviceTypeName, description, serviceStatus, onClick }: Props): React.ReactElement {
    const serviceStatusType = (): S.ServiceStatusProps => {
        if (serviceStatus === 'approve') {
            return { type: 'ACTIVE' };
        } else if (['doc_reject', 'interview_noanswer', 'interview_nonapprove', 'approve_reject', 'inactive', 'suspended'].includes(serviceStatus ?? '')) {
            return { type: 'INACTIVE' };
        } else {
            return {};
        }
    };
    return (
        <S.BtnService backGroundColor={'gray_opacity_50'} boarderColor={'gray_opacity_200'} onClick={onClick}>
            <S.ChildrenContainer>
                <S.LabelContainer>
                    <S.ServiceNameWrapper>
                        <Label contents={serviceTypeName} color={'gray_opacity_800'} fontStyle={'title_bold'} />
                        {serviceStatus && serviceStatus !== 'nodoc' ? <S.ServiceStatus {...serviceStatusType()}>{getServiceStatus(serviceStatus)}</S.ServiceStatus> : null}
                    </S.ServiceNameWrapper>
                    {description ? <S.LabelDescription contents={description} color={'gray_opacity_600'} fontStyle={'body1'} /> : null}
                </S.LabelContainer>
                <S.ServiceStatusWrapper>
                    <S.ArrowIcon />
                </S.ServiceStatusWrapper>
            </S.ChildrenContainer>
        </S.BtnService>
    );
}

export default BtnService;
